/*
 * @Author       : Tom
 * @Date         : 2019-12-16 10:19:24
 * @LastEditors  : Tom
 * @LastEditTime : 2020-01-17 17:11:08
 * @FilePath     : /shop_front_end/src/router/index.js
 * @Description  : 路由
 */
import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import {
	isLogin,
	setToken
} from '../lib/tool'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		component: Home,
		children: [{
				path: 'demo/table-upload',
				component: () => import( /* webpackChunkName: "home" */ '../views/demo/table-upload.vue'),
				meta: {
					name: 'table-upload-demo',
					index: '999998'
				}
			},

			{
				path: '',
				component: () => import( /* webpackChunkName: "home" */ '../views/home/home.vue'),
				meta: {
					name: '店铺首页',
					index: '1'
				}
			},
			{
				path: 'goodsmanage',
				component: () => import( /* webpackChunkName: "goodsmanage_router" */ '../views/router.vue'),
				meta: {
					name: '商品管理',
					index: '2'
				},
				children: [{
						path: '',
						component: () => import( /* webpackChunkName: "goods_manage" */ '../views/goods_manage/index.vue'),
					},
					{
						path: 'add',
						component: () => import( /* webpackChunkName: "goods_add" */ '../views/goods_manage/add.vue'),
						meta: {
							name: '发布商品'
						}
					},
					{
						path: 'import',
						component: () => import( /* webpackChunkName: "goods_add" */ '../views/goods_manage/importFile.vue'),
						meta: {
							name: '批量导入'
						}
					},
					{
						path: 'show',
						component: () => import( /* webpackChunkName: "goods_show" */ '../views/goods_manage/show.vue'),
						meta: {
							name: '查看商品'
						}
					},
					{
						path: 'edits/:id',
						component: () => import( /* webpackChunkName: "goods_edits" */ '../views/goods_manage/edits.vue'),
						meta: {
							name: '编辑商品'
						}
					},
					{
						path: 'optional',
						component: () => import( /* webpackChunkName: "goods_optional" */ '../views/goods_manage/optional.vue'),
						meta: {
							name: '添加商品'
						}
					},
					// 订单管理 运费设置
					{
						path: 'config',
						component: () => import( /* webpackChunkName: "order_config_router" */ '../views/router.vue'),
						meta: {
							name: '运费模板管理'
						},
						children: [{
								path: '',
								component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/config.vue'),
							},
							{
								path: 'add',
								component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/addconfig.vue'),
								meta: {
									name: '添加模板'
								},
							},
							{
								path: 'edit',
								component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/addconfig.vue'),
								meta: {
									name: '编辑'
								},
							},
							{
								path: 'view',
								component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/addconfig.vue'),
								meta: {
									name: '查看'
								},
							},
							{
								path: 'editor/:id',
								component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/editorconfig.vue'),
								meta: {
									name:'编辑模板'
								},
							},
							{
								path: 'view/:id',
								component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/editorconfig.vue'),
								meta: {
									name:'查看模板'
								},
							}
						]
					}
				]
			},
			{
				path: 'inventory',
				component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
				meta: {
					name: '库存管理',
					index: '9'
				},
				children: [{
						path: '',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/inventory/index.vue'),
					},
					{
						path: 'see',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/inventory/see.vue'),
						meta: {
							name: '库存详情'
						},
					},
					// {
					// 	path: 'edit/:id',
					// 	component: () => import( /* webpackChunkName: "order_manage" */ '../views/inventory/edit.vue'),
					// 	meta: {
					// 		name: '编辑门店'
					// 	},
					// },
				]
			},
			{
				path: 'ordermanage',
				component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
				meta: {
					name: '订单管理',
					index: '3'
				},
				children: [{
						path: '',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/order_manage/index.vue'),
					},
					// 订单管理 查看详情
					{
						path: 'details/:id',
						component: () => import( /* webpackChunkName: "order_manage_details" */ '../views/order_manage/details.vue'),
						meta: {
							name: '订单详情'
						},
					},
					// 订单管理 编辑订单
					{
						path: 'editor/:id',
						component: () => import( /* webpackChunkName: "order_manage_editor" */ '../views/order_manage/editor.vue'),
						meta: {
							name: '编辑订单'
						}
					},
					// 订单管理 发货
					{
						path: 'deliver/:id',
						component: () => import( /* webpackChunkName: "order_manage_deliver" */ '../views/order_manage/deliver.vue'),
						meta: {
							name: '发货'
						},
					},
					// 订单管理 售后审核
					{
						path: 'audit/:id',
						component: () => import( /* webpackChunkName: "order_manage_audit" */ '../views/order_manage/audit.vue'),
						meta: {
							name: '售后审核'
						}
					},
					//  订单管理  查看售后
					{
						path: 'see/:id',
						component: () => import( /* webpackChunkName: "order_manage_audit" */ '../views/order_manage/see.vue'),
						meta: {
							name: '售后查看'
						}
					},
					{
						path: 'ValetOrder',
						component: () => import( /* webpackChunkName: "order_manage_audit" */ '../views/order_manage/ValetOrder.vue'),
						meta: {
							name: '代客下单'
						}
					},
				]
			},
			{
				path: 'SettlementOrder',
				component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
				meta: {
					name: '订单结算',
					index: '10'
				},
				children: [
					{
						path: '',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/Settlement_Order/index.vue'),
					},
					{
						path: 'see',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/router.vue'),
						meta: {
							name: '查看'
						},
						children: [
							{
								path: '',
								component: () => import( /* webpackChunkName: "order_manage" */ '../views/Settlement_Order/see.vue'),

							},
							{
								path: 'Refund',
								component: () => import( /* webpackChunkName: "order_manage" */ '../views/Settlement_Order/Refund.vue'),
								meta: {
									name: '退款详情'
								},
							}
						]
					},

				]
			},
			{
				path: 'coupon',
				component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
				meta: {
					name: '优惠券',
					index: '7'
				},
				children: [{
						path: '',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/coupon/index.vue'),
					},
					// 订单管理 查看详情
					{
						path: 'add',
						component: () => import( /* webpackChunkName: "order_manage_details" */ '../views/coupon/add.vue'),
						meta: {
							name: '发行优惠券'
						},
					},
					{
						path: 'edits/:id',
						component: () => import( /* webpackChunkName: "order_manage_details" */ '../views/coupon/edits.vue'),
						meta: {
							name: '编辑优惠券'
						},
					},
					{
						path: 'record/:id',
						component: () => import( /* webpackChunkName: "order_manage_details" */ '../views/coupon/record.vue'),
						meta: {
							name: '领取记录'
						},
					},
					{
						path: 'giftSee/:id',
						component: () => import( /* webpackChunkName: "order_manage_details" */ '../views/coupon/giftSee.vue'),
						meta: {
							name: '赠送记录'
						},
					},
					{
						path: 'see/:id',
						component: () => import( /* webpackChunkName: "order_manage_details" */ '../views/coupon/see.vue'),
						meta: {
							name: '查看优惠券'
						},
					},
				]
			},
			{
				path: 'fundmanage',
				component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
				meta: {
					name: '资金管理',
					index: '4'
				},
				children: [
					{
						path: '',
						component: () => import( /* webpackChunkName: "fundmanage" */ '../views/fund_manage/index.vue'),
					},
					{
						path: 'withdrawal',
						component: () => import( /* webpackChunkName: "fundmanage" */ '../views/fund_manage/withdrawal.vue'),
						meta: {
							name: '提现',
							index: '4'
						},
					}
				]
			},
			// {
			// 	path: 'fundmanage',
			// 	component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
			// 	meta: {
			// 		index: '4'
			// 	},
			// 	children: [
			// 		{
			// 			path: '',
			// 			component: () => import( /* webpackChunkName: "fundmanage" */ '../views/fund_manage/index.vue'),
			// 			meta: {
			// 				name:  '资金管理'
			// 			},
			// 		},
			// 		{
			// 			path: 'withdrawal',
			// 			meta: {
			// 				name:  '首页'
			// 			},
			// 			children: [
			// 				{
			// 					path: '',
			// 					meta: {
			// 						name: '资金管理',
			// 					},
			// 					children: [
			// 						{
			// 							path: '',
			// 							meta: {
			// 								name: '银行卡'
			// 							},
			// 							children: [
			// 								{
			// 									path: '',
			// 									component: () => import( /* webpackChunkName: "fundmanage" */ '../views/fund_manage/withdrawal.vue'),
			// 									meta: {
			// 										name: '提现'
			// 									}
			// 								}
			// 							],
			//
			// 						}
			// 					]
			// 				}
			// 			]
			//
			// 		},
			// 	]
			// },

			{
				path: 'clientmanage',
				component: () => import( /* webpackChunkName: "clientmanage" */ '../views/router.vue'),
				meta: {
					name: '客户管理',
					index: '5'
				},
				children: [{
					path: '',
					component: () => import( /* webpackChunkName: "order_manage" */ '../views/client_manage/index.vue'),
				}]
			},
			{
				path: 'stores',
				component: () => import( /* webpackChunkName: "order_router" */ '../views/router.vue'),
				meta: {
					name: '公司办事处管理',
					index: '8'
				},
				children: [{
						path: '',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/stores/index.vue'),
					},
					{
						path: 'add',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/stores/add.vue'),
						meta: {
							name: '添加办事处地址'
						},
					},
					{
						path: 'edit/:id',
						component: () => import( /* webpackChunkName: "order_manage" */ '../views/stores/edit.vue'),
						meta: {
							name: '编辑门店'
						},
					},
				]
			},
			{
				path: 'shopset',
				component: () => import( /* webpackChunkName: "shopset_router" */ '../views/router.vue'),
				meta: {
					name: '店铺设置',
					index: '6'
				},
				children: [{
						path: '',
						component: () => import( /* webpackChunkName: "shopset_shopset" */ '../views/shop_set/index.vue')
					},
					{
						path: 'editor',
						component: () => import( /* webpackChunkName: "shopset_editor" */ '../views/shop_set/editor.vue'),
						meta: {
							name: '编辑'
						},
					},
					{
						path: 'addImg',
						component: () => import( /* webpackChunkName: "shopset_editor" */ '../views/shop_set/addImg.vue'),
						meta: {
							name: '添加轮播图'
						},
					},
					{
						path: 'modifyImg',
						component: () => import( /* webpackChunkName: "shopset_editor" */ '../views/shop_set/modifyImg.vue'),
						meta: {
							name: '编辑轮播图'
						},
					},
				]
			},
			// {
			//   path:'*',
			//   component: () => import(/* webpackChunkName: "404" */ '../views/err/404.vue')
			// }
		]
	},
	{
		path: '/login',
		name: 'login',
		component: () => import( /* webpackChunkName: "login" */ '../views/login/login.vue')
	},
	{
		path: '/forget',
		name: 'forget',
		component: () => import( /* webpackChunkName: "forget" */ '../views/login/forget.vue')
	},
	{
		path: '*',
		redirect: '/login'
	},
]

const router = new VueRouter({
	routes
})

// 全局前置守卫
router.beforeEach((to, from, next) => {
	if (location.href.includes('?token')) {
		let arr = location.href.split('?')[1].split('&')
		let option = {}
		arr.filter(item => {
			option[item.split('=')[0]] = item.split('=')[1]
		})
		if (option.token) {
			setToken({
				token: decodeURIComponent(option.token)
			})
		}
	}

	if (to.name === 'login' || to.name === 'forget') {
		next()
	} else {
		if (isLogin()) {
			next('/login')
		} else {
			next()
		}
	}
})

export default router
